import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { AuthProvider } from './contexts/AuthContext';
import AuthWrapper from './components/AuthWrapper';
import Login from './components/Login';
import Accesso from './components/Accesso';
import RequestPasswordReset from './components/RequestPasswordReset';
import ConfirmPasswordReset from './components/ConfirmPasswordReset';
import ForcePasswordChange from './components/ForcePasswordChange';
import Dashboard from './components/Dashboard';
import GroupAdminDashboard from './components/GroupAdminDashboard';
import AnomaliesManager from './components/AnomaliesManager';
import AdminTimesheet from './components/AdminTimesheet';
import MobilePresence from './components/MobilePresence';
import History from './components/History';
import Reports from './components/Reports';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import EmployeesList from './components/EmployeesList';
import DeletedEmployeesList from './components/DeletedEmployeesList';
import EmployeeDashboard from './components/EmployeeDashboard';
import DebugUsers from './components/DebugUsers';
import LeaveManagement from './components/LeaveManagement';
import Timesheet from './components/Timesheet';
import UserManagement from './components/UserManagement';
import PresenceValidation from './components/PresenceValidation';
import AdminGroupsManagement from './components/AdminGroupsManagement';
import ImpersonationManager from './components/ImpersonationManager';
import SystemAnnouncementAdmin from './components/SystemAnnouncementAdmin';
import NavigateToDashboard from './components/NavigateToDashboard';
import TimesheetsMassExport from './components/TimesheetsMassExport';
import LeaveBalanceImport from './components/LeaveBalanceImport';
import LeaveBalanceOverview from './components/LeaveBalanceOverview';
import MonthlyScheduleExport from './components/MonthlyScheduleExport';
import TimesheetManagement from './components/TimesheetManagement';
import GuidedPresenceEntry from './components/GuidedPresenceEntry';
import LeaveHistory from './components/LeaveHistory';
import LeaveReasonsAdmin from './components/LeaveReasonsAdmin';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <AuthWrapper>
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/accesso" element={<Accesso />} />
                <Route path="/reset-password" element={<RequestPasswordReset />} />
                <Route path="/confirm-password-reset" element={<ConfirmPasswordReset />} />
                <Route path="/force-password-change" element={<ForcePasswordChange />} />
                <Route path="/" element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }>
                  <Route index element={<NavigateToDashboard />} />
                  {/* Route admin - protette */}
                  <Route path="dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
                  <Route path="group-dashboard" element={<AdminRoute><GroupAdminDashboard /></AdminRoute>} />
                  <Route path="admin-timesheets" element={<AdminRoute><AdminTimesheet /></AdminRoute>} />
                  <Route path="timesheets-mass-export" element={<AdminRoute><TimesheetsMassExport /></AdminRoute>} />
                  <Route path="reports" element={<AdminRoute><Reports /></AdminRoute>} />
                  <Route path="anomalies" element={<AdminRoute><AnomaliesManager /></AdminRoute>} />
                  <Route path="timesheets-management" element={<AdminRoute><TimesheetManagement /></AdminRoute>} />
                  <Route path="guided-presence" element={<AdminRoute><GuidedPresenceEntry /></AdminRoute>} />
                  <Route path="employees" element={<AdminRoute><EmployeesList /></AdminRoute>} />
                  <Route path="employees/deleted" element={<AdminRoute><DeletedEmployeesList /></AdminRoute>} />
                  <Route path="users" element={<AdminRoute><UserManagement /></AdminRoute>} />
                  <Route path="admin-groups" element={<AdminRoute><AdminGroupsManagement /></AdminRoute>} />
                  <Route path="leave/import" element={<AdminRoute><LeaveBalanceImport /></AdminRoute>} />
                  <Route path="leave/balances" element={<AdminRoute><LeaveBalanceOverview /></AdminRoute>} />
                  <Route path="leave/history" element={<AdminRoute><LeaveHistory /></AdminRoute>} />
                  <Route path="leave/reasons" element={<AdminRoute><LeaveReasonsAdmin /></AdminRoute>} />
                  <Route path="reports/monthly-schedule" element={<AdminRoute><MonthlyScheduleExport /></AdminRoute>} />
                  {/* Route super admin - protette */}
                  <Route path="impersonation" element={<AdminRoute><ImpersonationManager /></AdminRoute>} />
                  <Route path="announcements" element={<AdminRoute><SystemAnnouncementAdmin /></AdminRoute>} />
                  <Route path="debug" element={<AdminRoute><DebugUsers /></AdminRoute>} />
                  {/* Route comuni - accessibili a tutti gli utenti autenticati */}
                  <Route path="mobile-presence" element={<MobilePresence />} />
                  <Route path="employee-dashboard" element={<EmployeeDashboard />} />
                  <Route path="history" element={<History />} />
                  <Route path="timesheet" element={<Timesheet />} />
                  <Route path="leave" element={<LeaveManagement />} />
                  <Route path="presence-validation" element={<PresenceValidation />} />
                </Route>
              </Routes>
            </Router>
        </AuthWrapper>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
